import { api } from 'src/api/axios';

export interface CancelOrderType {
  note: string;
}

export const useCancelOrder = (params: CancelOrderType, id: number) => api.post(`/api/cms/order/cancel/${id}`, params);
